import React from 'react';

import { LabelWrapper } from '~src/catalog/CatalogLabelsHookHelper';
import { CERTIFIED_INDICATOR_TYPE } from '~src/catalog/components/labels/DataQualityType';
import { Messages } from '~src/codegen/Localize';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

import { PublishedConnectionTooltip } from '../tooltips/PublishedConnectionTooltip';

const CertificationCardStyle: React.CSSProperties = {
  paddingTop: '3px',
  marginLeft: '-9px',
  marginRight: '-3px',
};

export class PublishedConnectionCard extends ContentCard {
  public render() {
    const {
      content, urls, hovered, selected, allowDragAndDrop, addContentFavorite, removeContentFavorite
    } = this.props;
    const contentUrl = getContentUrlForItem(content, urls);
    const imageUrl = PublishedConnections.getPublishedConnectionHeaderIconPath(content as ISpaceItemDetailInfo<'virtualConnection'>);

    const certificationsExist = content.dataQualityIndicators?.filter(i => i.type === CERTIFIED_INDICATOR_TYPE)[0] ?? null;

    const certificationComponent = certificationsExist ?
        <LabelWrapper itemInfo={content as IContentInfo<'virtualConnection'>}
                      category={'certification'}
                      isEager={false}
                      kind={'icon'}
                      wrapper={(e) => <div data-tb-test-id='virtualConnection-card-certification' style={CertificationCardStyle}>{e}</div>}/>: null;


    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          defaultImageUrl={imageUrl}
          thumbnailImageUrl={content.thumbnailUrl}
          hovered={hovered}
          selected={selected}
          navigateUrl={contentUrl}
          useBase64EncodedImage={true}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          {certificationComponent}
          <span data-tb-test-id="publishedConnection-name" className={CardViewStyles.ActionRowName} title={content.name}>
            {content.name}
          </span>
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.publishedConnectionTooltipTitle()}
            />
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'virtualConnection' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'virtualConnection' })}
            />
          </span>
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderPopoverContent = () => <PublishedConnectionTooltip
    content={this.props.content}
    urls={this.props.urls}
    inProjectSpace={this.props.inProjectSpace}
  />;
}
